import React, { useState } from 'react';
import styled from 'styled-components';
import { CHAR_DHAM_IMAGES } from "../../../../../shared/config/constants"


const ItineraryContainer = styled.div`
    background-color: #f2f2f2;
    padding-top: 24px;
    padding-left: 200px;
    padding-right: 200px;
    @media (max-width: 1477px) {
      padding-left: 50px;
      padding-right: 50px;
    }
`;

const ItineraryTitle = styled.p`
    font-size: 24px;
    font-weight: bold;
`;

const DropDownCard = styled.div`
  background-color: white;
  border-radius: 16px;
  margin-top: 18px;
  position: relative;
  padding: 16px;
  box-sizing: border-box;
  cursor: pointer;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const DayContainer = styled.div`
  width: 52px;
  height: 48px;
  background-color: #eaf5ff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const DayText = styled.p`
  margin: 0;
`;

const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 13px;
  flex: 1;
`;

const TitleText = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`;

const DistanceDurationContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const DistanceText = styled.p`
  margin-right: 10px;
`;

const DurationText = styled.p`
  margin: 0;
`;

const DropdownIconContainer = styled.div`
  cursor: pointer;
  position: absolute;
  right: 20px;
`;

const DropdownIcon = styled.img`
  width: 24px;
  height: 24px;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const ExtraInfoContainer = styled.div`
  margin-top: 10px;
`;

const ExtraInfoText = styled.p`
  margin: 0;
`;

const CardWithDropdown = ({ day, title, distance, duration, extraInfo }) => {
    const [isExpanded, setIsExpanded] = useState(false);
  
    return (
      <DropDownCard onClick={() => setIsExpanded(!isExpanded)}>
        <CardHeader>
          <DayContainer>
            <DayText>Day</DayText>
            <DayText>{day}</DayText>
          </DayContainer>
          <CardDetails>
            <TitleText>{title}</TitleText>
            <DistanceDurationContainer>
              <DistanceText>{distance}</DistanceText>
              <DurationText>{duration}</DurationText>
            </DistanceDurationContainer>
          </CardDetails>
          <DropdownIconContainer>
            <DropdownIcon
              src={CHAR_DHAM_IMAGES.DROP_DOWN}
              alt="dropdown-icon"
              isExpanded={isExpanded}
            />
          </DropdownIconContainer>
        </CardHeader>
        {isExpanded && (
          <ExtraInfoContainer>
            <ExtraInfoText>{extraInfo}</ExtraInfoText>
          </ExtraInfoContainer>
        )}
      </DropDownCard>
    );
  };


const CharDhamItinery = ({itineryList}) => {

    return (
        <ItineraryContainer>
        <ItineraryTitle>Detailed Itinerary for your selected route</ItineraryTitle>
        {itineryList.map((item, index) => (
            <CardWithDropdown
                key={index}
                day={index+1}
                title={item.route}
                distance={`${item.distance}kms`}
                duration={item.duration}
                extraInfo={item.details}
            />
        ))}
    </ItineraryContainer>
    )

}

export default CharDhamItinery;